import React from "react";
import {
  Route,
  Switch,
  Redirect,
  withRouter,
} from "react-router-dom";
import classnames from "classnames";
import { withStyles } from '@material-ui/styles';

import Header from "../Header/Header";

// pages
import UserSettings from "../../pages/usersettings/UserSettings";
import RotateDeviceWidget from "../../widgets/RotateDeviceWidget";
import StudentDashboard from "../../pages/studentDashboard/StudentDashboard";
import StudentCorsi from "../../pages/studentCorsi/StudentCorsi";
import EditCorsoStudent from "../../pages/editCorsoStudent/EditCorsoStudent";
import Sidebar from "../Sidebar/Sidebar";
import PdfCorsoPage from "../../pages/pdfCorsoPage/PdfCorsoPage";
import StudentSchedule from "../../pages/studentSchedule/StudentSchedule";
import NotificheStudenti from "../../pages/studentNotifiche/NotificheStudenti";
import translateString from "../../utils/Locales";
import { getServiceName } from "../../utils/consts";
import { ToastContainer } from 'react-toastify';
import '../Layout/ReactToastify.css';
import Exam from "../../pages/Exam/Exam";
import InfoTest from "../../pages/Exam/InfoTest";

let t = translateString;

const makeStyles = theme => ({
  root: {
    display: "flex",
    maxWidth: "100vw",
    overflowX: "hidden",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    width: `calc(100vw - 240px)`,
    minHeight: "100vh",
  },
  contentShift: {
    width: `calc(100vw - ${240 + theme.spacing(6)}px) `,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  fakeToolbar: {
    ...theme.mixins.toolbar,
  },
});

class StudentLayout extends React.Component {

  constructor(props){
    super(props)

    this.state = {
      menuItems: []
    }
  }

  handleResize() {
    if (window.innerWidth < 768 && window.innerHeight > window.innerWidth ) {
      this.setState({ isPortrait: true });
    } else {
      this.setState({ isPortrait: false });
    }
  }

  componentDidMount(){
    window.addEventListener('resize', this.handleResize.bind(this));
    this.handleResize();
    window.document.title = getServiceName() + ' - ' + t('studente').charAt(0) + t('studente').toLowerCase().slice(1);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize.bind(this));
  }


  render (){

    // global
    const { classes } = this.props;

    if (this.state.isPortrait) return <RotateDeviceWidget />;

    return (
      
      <div className={classes.root}>
          <>
            <Header history={this.props.history} />
            <Sidebar menuItems={this.state.menuItems}/>
            <ToastContainer style={{ marginTop: 60 }} />
            <div
              className={classnames(classes.content, {
                [classes.contentShift]: null,
              })}
            >
              <div className={classes.fakeToolbar} />
            
                  <Switch>

                    <Route path="/app/dashboard" component={StudentDashboard} />
                    <Route path="/app/corsi" component={StudentCorsi} />
                    <Route path="/app/editCorso" component={EditCorsoStudent} />
                    <Route path="/app/notifiche" component={NotificheStudenti} />
                    <Route path="/app/schedule" component={StudentSchedule} />
                    <Route path="/app/userSettings" component={UserSettings} />
                    <Route path="/app/pdfCorsoPage" component={PdfCorsoPage} />
                    <Route path="/app/infoTest" component={InfoTest} />
                    <Route path="/app/test" component={Exam} />

                    <Route
                      exact
                      path="/app/ui"
                      render={() => <Redirect to="/app/ui/icons" />}
                    />
                  </Switch>

            </div>
            <div
              className={classnames(classes.contentPhone)}
            >
            </div>
            <div className="lang-btn" style={{ position: 'fixed', top: 25, right: 150, zIndex: 2000 }} onClick={() => { this.setState({ }); window.sessionStorage.setItem('lang', 'it') }}><img src={ require('../../images/it.png') } style={{ width: 20, height: 'auto' }}/></div>
            <div className="lang-btn" style={{ position: 'fixed', top: 25, right: 120, zIndex: 2000 }} onClick={() => { this.setState({ }); window.sessionStorage.setItem('lang', 'en') }}><img src={ require('../../images/en.png') } style={{ width: 20, height: 'auto' }}/></div>
          </>
      </div>
    );
  }
  
}

export default withStyles(makeStyles)(withRouter(StudentLayout));
